'use strict';

var isGbipUnitTestHarness = require('./gbipUnitTestHarness.js');

var REACT_REDIRECT_STATES = {
  search: true,
  'queue.qa': true,
  'queue.post-prod': true,
  detail: true,
  admin: true,
};

var RouteChange = /*@ngInject*/ function (
  $rootScope,
  $window,
  AUTH_EVENTS,
  AuthService,
  $timeout,
  $location,
  localStorageService,
  ReactNavigationService
) {
  $rootScope.$on('$stateChangeStart', function (event, next, toParams) {
    var authorizedRoles = null;

    if (next.data) {
      authorizedRoles = Object.keys(next.data.authorizedRoles);
    }

    if (!AuthService.isAuthorized(authorizedRoles)) {
      event.preventDefault();
      $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
      return;
    }

    if (!isGbipUnitTestHarness() && REACT_REDIRECT_STATES[next.name]) {
      event.preventDefault();

      switch (next.name) {
        case 'search':
          ReactNavigationService.goToSearch(toParams.q);
          break;
        case 'queue.qa':
          ReactNavigationService.goToQAQueue(
            $location.search().tab || toParams.tab
          );
          break;
        case 'queue.post-prod':
          ReactNavigationService.goToPostProdQueue();
          break;
        case 'detail':
          if (toParams.jobId) {
            ReactNavigationService.goToJobDetail(toParams.jobId);
          } else {
            ReactNavigationService.goToProductDetail(toParams.productIdentifier);
          }
          break;
        case 'admin':
          if (
            toParams.section === 'bulk-job-update' ||
            toParams.section === 'record-links'
          ) {
            ReactNavigationService.goToAdmin(toParams.section);
          } else {
            ReactNavigationService.goToHome();
          }
          break;
      }

      return;
    }

    var preRedirect = localStorageService.get('pre-redirect');
    if (preRedirect > '') {
      event.preventDefault();
      localStorageService.remove('pre-redirect');
      $window.location.assign(preRedirect);
    }

    if (next.pageTitle) {
      $timeout(function () {
        document.title = next.pageTitle;
      }, 0);
    }
  });
};

module.exports = RouteChange;
